import { apiFetch } from '../lib/apiFetch';

/**
 * An ACH debit that is still in flight — submitted to Auth.Net but neither
 * settled nor returned. Sourced from the backend /payments/ach/unsettled
 * worklist (payment_authorizations joined to the ledger + order/customer).
 */
export interface UnsettledAch {
  transaction_id: string;
  authorized_at: string | null;
  /** Whole days since the debit was authorized (null if unknown). */
  age_days: number | null;
  /** Past the T+1..T+5 ACH return window — overdue to settle. */
  overdue: boolean;
  account_holder_name: string;
  account_last4: string;
  account_type: string;
  /** Captured total in cents (order base + technology fee). */
  amount_cents: number;
  order_id: string;
  order_number: number | null;
  customer_name: string;
  customer_email: string | null;
}

export const fetchUnsettledAch = async (): Promise<UnsettledAch[]> => {
  const res = await apiFetch('/payments/ach/unsettled');
  if (!res.ok) throw new Error('Failed to load unsettled ACH transactions');
  const data = await res.json();
  return data.data || [];
};
